import { useState } from 'react'
import {
    KARAKTERISTIKE_14509,
    KARAKTERISTIKE_13165,
    STANDARD_OPTIONS,
} from '../config/dopConfig'

import { getDopTranslation } from '../config/helpers'

const Step4KarakteristikeDopa = ({ formData, setFormData }: any) => {
    const debljine = formData.debljine || []
    const [activeIndex, setActiveIndex] = useState(0)

    const currentDebljina = debljine[activeIndex]
    const lang = formData.lang || 'bs'

    const karakteristikeConfig =
        formData.standard === 'EN_13165_2017'
            ? KARAKTERISTIKE_13165
            : KARAKTERISTIKE_14509

    const t = (key: string) => getDopTranslation(lang, key)

    const currentData = formData.karakteristike?.[currentDebljina] || {}

    const updateValue = (key: string, value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            karakteristike: {
                ...prev.karakteristike,
                [currentDebljina]: {
                    ...prev.karakteristike?.[currentDebljina],
                    [key]: {
                        ...prev.karakteristike?.[currentDebljina]?.[key],
                        value,
                    },
                },
            },
        }))
    }

    const updateStandard = (key: string, standardValue: string) => {
        setFormData((prev: any) => {
            const currentRow = prev.karakteristike?.[currentDebljina]?.[key] || {}

            return {
                ...prev,
                karakteristike: {
                    ...prev.karakteristike,
                    [currentDebljina]: {
                        ...prev.karakteristike?.[currentDebljina],
                        [key]: {
                            ...currentRow,
                            standard: standardValue,
                            value: standardValue === 'NPD' ? '' : currentRow.value || '',
                        },
                    },
                },
            }
        })
    }

    if (!debljine.length) {
        return (
            <div className="alert alert-warning">
                Nema odabranih debljina.
            </div>
        )
    }

    return (
        <div>
            <div className="alert alert-info d-flex align-items-center mb-6">
                <div>
                    <div className="fw-bold mb-1">Napomena</div>
                    <div>
                        Odaberi standard, nakon toga upiši vrijednost.
                        Ako je odabran <strong>NPD</strong>, vrijednost se automatski briše.
                    </div>
                </div>
            </div>

            <div className="text-center mb-6">
                <h3 className="fw-bold mb-1">
                    Debljina: {currentDebljina} mm
                </h3>

                <div className="text-muted">
                    Korak {activeIndex + 1} od {debljine.length}
                </div>
            </div>

            <div className="d-flex justify-content-center gap-2 mb-6 flex-wrap">
                {debljine.map((d: number, index: number) => (
                    <button
                        type="button"
                        key={d}
                        onClick={() => setActiveIndex(index)}
                        className={`btn btn-sm ${
                            index === activeIndex ? 'btn-primary' : 'btn-light'
                        }`}
                    >
                        {d} mm
                    </button>
                ))}
            </div>

            <div className="card shadow-sm border">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-row-bordered align-middle mb-0">
                            <thead className="bg-light">
                            <tr className="fw-bold text-muted">
                                <th className="ps-4 min-w-250px">Karakteristika</th>
                                <th style={{ width: '240px' }}>Standard</th>
                                <th style={{ width: '240px' }}>Vrijednost</th>
                            </tr>
                            </thead>

                            <tbody>
                            {karakteristikeConfig.map((item: any) => {
                                const itemLabel = item.translationKey
                                    ? t(item.translationKey)
                                    : item.label

                                if (item.isGroup) {
                                    return (
                                        <tr
                                            key={item.translationKey || item.label}
                                            className="bg-light fw-bold"
                                        >
                                            <td colSpan={3} className="ps-4 py-3">
                                                {itemLabel}
                                            </td>
                                        </tr>
                                    )
                                }

                                const key = item.key as string
                                const rowData = currentData?.[key] || {}
                                const selectedStandard = rowData.standard || 'NPD'
                                const isNpd = selectedStandard === 'NPD'

                                return (
                                    <tr key={key}>
                                        <td className="ps-4 fw-semibold">
                                            {itemLabel}
                                        </td>

                                        <td>
                                            <select
                                                className="form-select"
                                                value={selectedStandard}
                                                onChange={(e) =>
                                                    updateStandard(key, e.target.value)
                                                }
                                            >
                                                {STANDARD_OPTIONS.map((s) => (
                                                    <option key={s.value} value={s.value}>
                                                        {s.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>

                                        <td>
                                            {item.type === 'select' ? (
                                                <select
                                                    className="form-select"
                                                    value={rowData.value || ''}
                                                    disabled={isNpd}
                                                    onChange={(e) =>
                                                        updateValue(key, e.target.value)
                                                    }
                                                >
                                                    <option value="">
                                                        {isNpd ? 'NPD' : 'Odaberi'}
                                                    </option>

                                                    {item.options?.map((option: string) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={rowData.value || ''}
                                                    disabled={isNpd}
                                                    placeholder={isNpd ? 'NPD' : 'Upiši vrijednost'}
                                                    onChange={(e) =>
                                                        updateValue(key, e.target.value)
                                                    }
                                                />
                                            )}
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between mt-6">
                <button
                    type="button"
                    className="btn btn-light"
                    disabled={activeIndex === 0}
                    onClick={() => setActiveIndex((prev) => prev - 1)}
                >
                    ← Prethodna debljina
                </button>

                <button
                    type="button"
                    className="btn btn-success"
                    disabled={activeIndex === debljine.length - 1}
                    onClick={() => setActiveIndex((prev) => prev + 1)}
                >
                    Sljedeća debljina →
                </button>
            </div>
        </div>
    )
}

export default Step4KarakteristikeDopa